import React from 'react';
import styles from './styles.scss';

import { Icons } from '@densityco/ui';

const BackButton: React.FunctionComponent<{}> = () => (
  <button data-test-id="back-button" className={styles.back} onClick={() => window.history.back()}>
    <Icons.ArrowLeft />
  </button>
);
export default BackButton;
